import React, {useEffect, useState }  from 'react';
import { connect } from 'react-redux';
import { getItem } from '@craftercms/content';
import { languagePicker, setCookieLaw} from '../../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import CookieLawBarHolder from './CookieLawBarStyles';

const CookieBar = (props) => {
  const [message, setMessage] = useState('CPAC uses cookies to provide you with the best possible browsing experience on our website, and to show you relevant online ads through our advertising partners. By continuing to use our site, you agree to our use of cookies. Visit our <a href="//www.cpac.ca/en/privacy-policy/" target="_blank" class="privacy-link">Privacy Policy</a> page to learn more or click “<a href="#" id="cookie_reject">I Disagree</a>” to opt-out of advertising cookies.');
  
  const cookieYesButtonHandler = () => {
    setCookieLaw(true);
    props.setCookieLaw(true);
  
  }

  const cookieNoButtonHandler = (e) => {
    if(e.target.id === "cookie_reject") {
      setCookieLaw(false); 
      props.setCookieLaw(true);
    }
  }

  useEffect(()=> {
    getItem("/site/components/common/cookielawbar.xml").subscribe((item) => {
      if (item) {
        const fieldNames = ["message_html"];
        languagePicker(item, fieldNames);
        setMessage(item.descriptorDom.component.message);
      }
    });
  },[props.current_lang]);


  return (
    <CookieLawBarHolder> 
      <div className="cookie-law-bar"> 
        <div className="cookies-message" dangerouslySetInnerHTML={{__html: message}} onClick={cookieNoButtonHandler} />        
        <div className="cookies-buttons">
          <a className="cookies-yes-button" onClick={cookieYesButtonHandler}>
            <FontAwesomeIcon icon={faTimes} />
          </a>
        </div>
      </div>
    </CookieLawBarHolder>
  )
}

const mapStateToProps = (store) => ({
  current_lang: store.language.current
});

const mapDispatchToProps = (dispatch) => ({
  setCookieLaw: (cookieLaw) => dispatch({ type: 'SET_COOKIE_LAW', cookieLaw: cookieLaw })
});

export default connect(mapStateToProps,mapDispatchToProps)(CookieBar);